import React from 'react';
import { useTranslation } from 'react-i18next';
import { Flex, Statistic, TextComponent } from '@monorepo/react-components';
import { PayoutSource } from '@monorepo/types';

interface PayoutHeaderProps {
  source: PayoutSource;
  displayName: string;
  maxWithdrawal: number;
}

export const PayoutHeader: React.FC<PayoutHeaderProps> = ({
  source,
  displayName,
  maxWithdrawal,
}) => {
  const { t } = useTranslation(['withdrawFunds']);
  const isAccountPayout = source === PayoutSource.Account;
  const title = t('withdrawFunds:title', {
    source,
    isAccountPayout: isAccountPayout ? '#' : '',
    displayName,
  });

  return (
    <Flex vertical align="center" gap={10}>
      <TextComponent level={2} weight={600} className="title">
        {title}
      </TextComponent>
      <TextComponent textAlign="center">
        {t('withdrawFunds:available_balance')}
        <TextComponent weight={600}>
          <Statistic prefix="$" value={maxWithdrawal} precision={2} />
        </TextComponent>
      </TextComponent>
    </Flex>
  );
};
